import React from 'react';

export const VipWingSVG = () => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="16" cy="16" r="16" fill="#982EA9" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.5239 7.75146C22.3609 9.29999 21.2901 9.95546 19.3546 10.3539C12.528 11.7594 11.814 12.6119 10.337 13.9169C6.3094 17.4736 8.19093 23.5511 8.19093 24.2485C9.13406 23.0868 9.67061 22.8594 11.0502 22.548C12.2694 22.2728 13.8703 22.5645 14.6157 22.548C16.8577 22.4977 18.793 21.5445 19.507 20.0388C18.794 19.9886 17.6218 19.888 17.3677 19.2858C21.9012 18.9847 23.2772 15.974 23.2772 14.3683C22.3594 14.7699 21.3919 14.8198 20.6935 14.7221C24.0918 13.114 24.1868 10.9115 24.2455 9.75167C24.2967 8.7481 23.7599 7.75146 23.5239 7.75146Z"
            fill="white"
        />
    </svg>
);
